var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.tableau = function (widget, chart) {
    var otherConfig = widget.data('config') || {};
    var MAP = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    function htmlEscape(item) {
        return item.toString().replace(/[&<>'"]/g, function(char) {
            return MAP[char]; 
        });
    }

    setTimeout(function () {
        widget.find('.loading-box').hide();
        chart.empty().show();
        var container = $('<div class="tableauPlaceholder">')
            .width(widget.find('.box-primary').width())
            .height(widget.find('.box-primary').height() - widget.find('.box-header').outerHeight() - widget.find('.ui-icon-gripsmall-diagonal-se').height());
        var domObj = $('<object class="tableauViz" style="display:none;">')
            .width(widget.find('.box-primary').width())
            .height(widget.find('.box-primary').height() - widget.find('.box-header').outerHeight() - widget.find('.ui-icon-gripsmall-diagonal-se').height());
        
        var params = otherConfig.tableau.params;
        var keys = Object.keys(params);
        for (var i = 0; i < keys.length; i++) {
            var value = otherConfig.tableau.params[keys[i]];
            if (keys[i] == 'host_url') {
                value = encodeURIComponent(value);
            }
            $('<param />')
                .attr('name', keys[i])
                .attr('value', value)
                .appendTo(domObj);
        }
        container.append(domObj);
        chart.append("<script type='text/javascript' src='https://tableau-dpn.leadq.nl/javascripts/api/viz_v1.js'></script>");
        chart.append(container);
    }, 0);

};